import { IReduxAction, actionGenerator } from '../../redux/actionGenerator';

export const SET_BUY_PACKAGE_LOADING = 'BUY_PACKAGE :: LOADING';

interface IBuyPackageLoading {
  isLoading: boolean;
}

export type TSetBuyPackageLoadingAction = IReduxAction<typeof SET_BUY_PACKAGE_LOADING, IBuyPackageLoading>;

export const setBuyPackageLoading = actionGenerator<typeof SET_BUY_PACKAGE_LOADING, IBuyPackageLoading>(
  SET_BUY_PACKAGE_LOADING,
);
